import React from 'react';
import EarningsSurpriseWidgetRenderer from './EarningsSurpriseWidgetRenderer';

const Preview: React.FC = () => (
  <EarningsSurpriseWidgetRenderer config={{}} />
);

export default Preview;
